/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidLevelingsControllerUpdateMutationRequest, BidLevelingsControllerUpdateMutationResponse, BidLevelingsControllerUpdatePathParams, BidLevelingsControllerUpdate400, BidLevelingsControllerUpdate401, BidLevelingsControllerUpdate403, BidLevelingsControllerUpdate404 } from "../../models/bidsController/BidLevelingsControllerUpdate";

function getBidLevelingsControllerUpdateUrl(id: BidLevelingsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/bid-levelings/${id}` as const }  
  return res
}

/**
 * @summary Rename, archive or restore a trade, change its row source or latest addendum, or set or clear its winner
 * {@link /api/v1/bid-levelings/:id}
 */
export async function bidLevelingsControllerUpdate(id: BidLevelingsControllerUpdatePathParams["id"], data?: BidLevelingsControllerUpdateMutationRequest, config: Partial<RequestConfig<BidLevelingsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<BidLevelingsControllerUpdateMutationResponse, ResponseErrorConfig<BidLevelingsControllerUpdate400 | BidLevelingsControllerUpdate401 | BidLevelingsControllerUpdate403 | BidLevelingsControllerUpdate404>, BidLevelingsControllerUpdateMutationRequest>({ method : "PATCH", url : getBidLevelingsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}